export default class CmsPages {
    // Core reference point to query CMS children
    private cmsPage: HTMLElement | null


    static instance: CmsPages = new CmsPages()


    constructor() {
        this.cmsPage = document.querySelector(".cms-page")
    }


    setElementClassProperty(element: string, classlist: string): void {
        const elementTag = this.cmsPage?.querySelectorAll(element) as NodeListOf<HTMLElement>
        elementTag?.forEach(el => el.classList.add(classlist))
    }



    removeEmptyElementTags(element: string): void {
        const elementTag = this.cmsPage?.querySelectorAll(element) as NodeListOf<HTMLElement>
        elementTag?.forEach(el => {
            if (el.textContent && el.parentNode) {
                el.textContent.trim() === "" && el.parentNode.removeChild(el)
            }
        })
    }

    removeAttributes(element: string, ...args: string[]) {
        const elementTag = this.cmsPage?.querySelectorAll(element) as NodeListOf<HTMLElement>
        if(elementTag) {
          for (const item of elementTag) {
              item && args.forEach(attribute => item.removeAttribute(attribute))
          }
        }
    }
    
}
